/*eslint no-unused-vars: 0*/

const PartnerPodcastsSlider = (target) => {
  const initSlider = ($el, params) => {
    $el.slick(params);
  };

  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        slidesToShow: 1.1,
        variableWidth: true,
        arrows: false,
        dots: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 9999,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              variableWidth: false,
              dots: false,
              arrows: true,
              prevArrow: '<button class="slick-arrow slick-prev"><i class="icon icon-arrow"></i></button>',
              nextArrow: '<button class="slick-arrow slick-next"><i class="icon icon-arrow"></i></span></button>',
            },
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.1,
              variableWidth: true,
            },
          },
        ],
      }
      initSlider($el, params);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default PartnerPodcastsSlider;



// WEBPACK FOOTER //
// ./scripts/components/PartnerPodcastsSlider.js